import type { MembershipPlanId } from "@/types/membership";

import type { PoolsListItem } from "./data";

export type PoolsQueryFeatures = {
	has7DayPerformance: boolean;
	has30DayPerformance: boolean;
	canSortTvl: boolean;
	canSortApr7d: boolean;
	canSortApr30d: boolean;
	hasCsvDataDownloads: boolean;
};

export type PoolsQueryResponse = {
	pools: PoolsListItem[];
	total: number;
	userPlan: MembershipPlanId;
	features: PoolsQueryFeatures;
};

export function poolsQueryKey(scope: string) {
	return ["pools", scope] as const;
}
